<template>
  <div class="package-dates">
    <h2 class="content-panel__title">Your important dates</h2>

    <div class="package-date">
      <div class="title">Utilities start date:</div>
      <time :datetime="tenancyStartDate" data-testid="tenancy-start-date">
        {{ tenancyStartDate | FormatDate }}
      </time>
    </div>
    <div class="package-date">
      <div class="title">Utilities end date:</div>
      <time :datetime="tenancyEndDate" data-testid="tenancy-end-date">
        {{ tenancyEndDate | FormatDate }}
      </time>
    </div>
    <div class="package-date">
      <div class="title">First payment date:</div>
      <time :datetime="firstPaymentDate" data-testid="first-payment-date">
        {{ firstPaymentDate | FormatDate }}
      </time>
    </div>
    <div class="package-date" v-if="broadbandInstallationDate">
      <div class="title">Preferred broadband install:</div>
      <time
        :datetime="broadbandInstallationDate"
        data-testid="broadband-start-date"
      >
        {{ broadbandInstallationDate | FormatDate }}
      </time>
    </div>
  </div>
</template>

<script>
import FormatDate from "@/filters/FormatDate";

export default {
  name: "PackageSchedule",
  props: {
    tenancyStartDate: {
      type: String,
      required: true,
    },
    tenancyEndDate: {
      type: String,
      required: true,
    },
    firstPaymentDate: {
      type: String,
      required: true,
    },
    broadbandInstallationDate: {
      type: String,
      required: false,
    },
  },
  filters: {
    FormatDate,
  },
};
</script>

<style lang="scss" scoped>
.package-dates {
  display: flex;
  flex-direction: column;
  background: $white;

  h2 {
    text-align: start;
    color: $brand-dark-blue;
  }

  .package-date {
    margin-bottom: 3.25rem;
    font-size: 18px;

    .title {
      font-weight: $font-bold;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
